module.exports = __webpack_public_path__ + "media/images/products/banners/as_melhores_ações-be7a2eb32d09898c5cc818be7b70d391.png";